import { Box, MenuItem, Select, TextField, Typography } from "@mui/material";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import pageTextConfig from "../../../assets/configs/Add New Gig Page/ListingDetailsPage/textConfig";
import { GigFormDataInterface } from "../SellerDashboardComponents/DashboardSections/GigEditingPage";

export interface PriceTableRowFormInterface {
    minPrice: number | undefined,
    maxPrice: number | undefined,
    duration: number | undefined,
    durationUnit: string,
    description: string,
}

export const PriceTableRow: React.FC<{
    index: number
    gigFormData: GigFormDataInterface,
    updatePriceTableRow: any,
    deletePriceTableRow: any,
    editMode ?: boolean;
}> = ({ index, gigFormData, updatePriceTableRow, deletePriceTableRow , editMode }) => {
    if(editMode === undefined){
        editMode = true;
    }
    
    return (
        <Box className='price-table-row'>
            <Box className='price-range-block' width={{ xs: '48%', md: '24%' }}>
                <Typography variant='body2' fontWeight='600'> {pageTextConfig.formSection.gigPriceTableSection.gigPriceRangeTitle} </Typography>
                <Box className='text-fields'>
                    <TextField 
                        size='small' 
                        value={gigFormData.priceTable[index].minPrice} 
                        name="minPrice" 
                        onChange={(e) => {
                            e.target.value = e.target.value.replace(/[^\d]+/, '')
                            updatePriceTableRow(e, index)
                        }} 
                        InputProps={{ style: { fontFamily: "Arial" } }} 
                        inputProps={{ maxLength: 20 }}
                        variant='outlined' 
                        placeholder="Min" 
                        sx={{ marginRight: '8px' }} 
                        disabled={!editMode}
                    />
                    <TextField 
                        size='small' 
                        value={gigFormData.priceTable[index].maxPrice} 
                        name="maxPrice" 
                        onChange={(e) => {
                            e.target.value = e.target.value.replace(/[^\d]+/, '')
                            updatePriceTableRow(e, index)
                        }} 
                        InputProps={{ style: { fontFamily: "Arial" } }} 
                        inputProps={{ maxLength: 20 }}
                        variant='outlined' 
                        placeholder="Max" 
                        disabled={!editMode}
                    />
                </Box>
            </Box>
            <Box className='duration-block' width={{ xs: '48%', md: '24%' }}>
                <Typography variant='body2' fontWeight='600'>{pageTextConfig.formSection.gigPriceTableSection.approxDurationTitle} </Typography>
                <Box className='text-fields'>
                    <TextField 
                        size='small' 
                        name='duration' 
                        value={gigFormData.priceTable[index].duration} 
                        onChange={(e) => {
                            e.target.value = e.target.value.replace(/[^\d]+/, '')
                            updatePriceTableRow(e, index)
                        }} 
                        InputProps={{ style: { fontFamily: "Arial" } }} 
                        inputProps={{ maxLength: 5 }}
                        variant='outlined' 
                        placeholder="Duration" 
                        sx={{ marginRight: '8px', width: '50%' }} 
                        disabled={!editMode}
                    />
                    <Select
                        value={gigFormData.priceTable[index].durationUnit}
                        name="durationUnit"
                        onChange={(e) => updatePriceTableRow(e, index)}
                        size="small"
                        sx={{ width: '50%' }}
                        disabled={!editMode}
                    >
                        <MenuItem value={"hours"}>Hour(s)</MenuItem>
                        <MenuItem value={"days"}>Day(s)</MenuItem>
                        <MenuItem value={"weeks"}>Week(s)</MenuItem>
                        <MenuItem value={"months"}>Month(s)</MenuItem>
                    </Select>
                </Box>
            </Box>

            <Box className='description-block' width={{ xs: '100%', md: '48%' }}>
                <Typography variant='body2' fontWeight='600'> {pageTextConfig.formSection.gigPriceTableSection.descriptionTitle} </Typography>
                <Box className='text-fields'>
                    <TextField 
                        size='small' 
                        value={gigFormData.priceTable[index].description} 
                        name="description" 
                        onChange={(e) => updatePriceTableRow(e, index)} 
                        InputProps={{ style: { fontFamily: "Arial" } }} 
                        variant='outlined' 
                        placeholder="Description" 
                        fullWidth
                        multiline
                        rows={4}
                        disabled={!editMode}
                        inputProps={{ maxLength: 500 }}
                        helperText={`${gigFormData.priceTable[index].description.length}/500 characters (minimum 50)`}
                    />
                </Box>
            </Box>
            {gigFormData.priceTable.length !== 1 && <CancelRoundedIcon className="delete-icon" fontSize='large' color="error" onClick={(e) => deletePriceTableRow(index)} />}
        </Box>
    )
}

